import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications/dist/ToastProvider';
import Loading from '../components/Loading';
import UploadQueueModal from '../components/UploadQueueModal';
import Router from '../routers/Router';
import { AuthProvider } from './AuthContext';
import { LoadingProvider } from './LoadingContext';
import { OrdersDataProvider } from './OrdersDataContext';
import { UploadQueueProvider } from './UploadQueueContext';

const Providers = () => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <LoadingProvider>
          <UploadQueueProvider>
            <AuthProvider>
              <OrdersDataProvider>
                <Router />
              </OrdersDataProvider>
            </AuthProvider>
            <Loading />
            <UploadQueueModal />
          </UploadQueueProvider>
        </LoadingProvider>
      </ToastProvider>
    </BrowserRouter>
  );
};

export default Providers;